import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=5e48eb5a&"
import script from "./Simulation.vue?vue&type=script&lang=ts&"
export * from "./Simulation.vue?vue&type=script&lang=ts&"
import style0 from "./Simulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports